export * from '@fhs/routing/src/routes/auth/signup/index';
export { default } from '@fhs/routing/src/routes/auth/signup/index';
